import { useMemo } from "react";
import { ScaleLinear } from "d3";

type AxisLeftProps = {
    yScale: ScaleLinear<number, number>;
    pixelsPerTick: number;
    width: number;
};

const TICK_LENGTH = 10;

export const AxisLeft = ({ yScale, pixelsPerTick, width }: AxisLeftProps) => {
    const range = yScale.range();

    const ticks = useMemo(() => {
        const height = range[0] - range[1];
        const numberOfTicksTarget = Math.floor(height / pixelsPerTick);

        return yScale.ticks(numberOfTicksTarget).map((value) => ({
            value,
            yOffset: yScale(value),
        }));
    }, [yScale]);

    return (
        <>
            <text
              textAnchor="middle"
              transform={`translate(-45, ${(range[0] - range[1]) / 2}) rotate(-90)`}
              style={{ fontSize: 16 }}
            >
                Production capabilities of model well in tons per year
            </text>
            {/* Ticks and labels */}
            {ticks.map(({ value, yOffset }) => (
                <g
                    key={value}
                    transform={`translate(0, ${yOffset})`}
                    shapeRendering={"crispEdges"}
                >
                    <line
                        x1={-TICK_LENGTH}
                        x2={width + TICK_LENGTH}
                        stroke="#D2D7D3"
                        strokeWidth={0.5}
                    />
                    <text
                        key={value}
                        style={{
                            fontSize: "20px",
                            textAnchor: "middle",
                            transform: "translateX(-20px)",
                            fill: "#D2D7D3",
                        }}
                    >
                        {value}
                    </text>
                </g>
            ))}
        </>
    );
};
